import { createStore } from "owa-satcheljs";

export enum LoadState {
    OptionsNotLoaded,
    OptionsLoading,
    OptionsLoaded
}

export interface OwsOptionsLoadStateStore {
    loadState: LoadState;
}

const defaultStore: OwsOptionsLoadStateStore = {
    loadState: LoadState.OptionsNotLoaded,
};

export const getOptionsLoadState: () => OwsOptionsLoadStateStore = createStore("owsOptionsLoadStateStore", defaultStore);
